/**
* Web Service handler to transmit new Appointment information to the consumer via email
*
* @class AppointmentConfirmationEmailWS
*/
function AppointmentConfirmationEmailWS (parent) {
	var self = this;

	AbstractWS.apply( this, arguments );

	self.method	= ko.observable( 'POST' );
	self.name = 'AppointmentConfirmationEmailWS';


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL = ko.computed( function () {
		return '/qless/api/v1/appointment/confirmationEmail';
	});


	/**
	* Prototype override method
	*
	* @method doRequest
	* @param {String} sConfirmationCode
	* @param {String} sLocale
	* @return none
	*/
	self.doRequest = function ( sConfirmationCode, sLocale ) {
		sLocale = sLocale || 'en';

		self.addParam('confirmationCode', sConfirmationCode);
		self.addParam('locale', sLocale);

		AbstractWS.prototype.doRequest.call(self);
	};

	return self;
};

AppointmentConfirmationEmailWS.prototype = AbstractWS.prototype;
AppointmentConfirmationEmailWS.prototype.constructor = AppointmentConfirmationEmailWS;
